<template>
  <div class="list">
    <Headers></Headers>
    <div
      class="banner"
      style="background: url(/static/banner/services.png) center"
    >
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">我们的服务</div>
          <div class="entitle">Our services</div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="listbox">
      <div class="container">
        <Left></Left>
        <List></List>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import Left from '@/components/services/left/left.vue'
import List from '@/components/services/list/list.vue'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'list',
  mixins: [setmeta],
  data () {
    return {
    }
  },
  components: {
    Headers,
    Footer,
    Left,
    List
  },
  methods: {},
  created () {
    this.setMetaConfig({
      web_title: `服务项目-${this.$env.TITLE}`
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./list";
</style>



// WEBPACK FOOTER //
// src/views/services/list/list.vue